// extracted by mini-css-extract-plugin
export default {"tenantUsersTable":"TenantUsersTable_tenantUsersTable__IylKC","\t":"TenantUsersTable_-__nDzmN","spinner":"TenantUsersTable_spinner__249+X"};